import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  REPORTS_RESET_REPORTS_ORDER_DETAIL_LEVEL_DATA,
} from './constants';

export function resetReportsOrderDetailLevelData() {
  return {
    type: REPORTS_RESET_REPORTS_ORDER_DETAIL_LEVEL_DATA,
  };
}

export function useResetReportsOrderDetailLevelData() {
  const dispatch = useDispatch();
  const boundAction = useCallback((...params) => dispatch(resetReportsOrderDetailLevelData(...params)), [dispatch]);
  return { resetReportsOrderDetailLevelData: boundAction };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_RESET_REPORTS_ORDER_DETAIL_LEVEL_DATA:
      return {
        ...state,
        reportsOrderDetailData: null,
        reportsOrderDetailTotals: 0,
        orderDetailSummary: null,
      };

    default:
      return state;
  }
}
